import { makeQuery } from 'shared/utilities';

type ResponseType = {};

export const usersPingQuery = async function () {
    return await makeQuery<ResponseType>('/users/ping', {
        forceLogout: false
    });
}
